module.exports = __webpack_public_path__ + "img/tz.416b477b.svg";